import { useTemplateEditMode } from '../../context/TemplateEditMode/TemplateEditMode'
import { useQueryTemplateSpecificMultipleChoices } from '../api/useQueryTemplateSpecificMultipleChoices'

export const useTemplateSpecificMultipleChoices = () => {
  const templateEditMode = useTemplateEditMode()

  const query = useQueryTemplateSpecificMultipleChoices(templateEditMode)

  return {
    templateSpecificMultipleChoiceGroups: query.data ?? [],
    isError: query.isError,
    error: query.error,
    isLoading: query.isLoading,
  }
}
